import styled from 'styled-components';
import React, { useState } from "react";
import { useNavigate, Link,useLocation } from 'react-router-dom';

import BannerPrincipal from './ItensPaginas/BannerPrincipal.js';
import Contato from './ItensPaginas/Contato.js';
import ItemTexto from './ItensPaginas/ItemTexto.js';
import QuatroBanner from './ItensPaginas/QuatroBanner.js';
import SetorUm from './ItensPaginas/SetorUm.js';
import Perfil from './ItensPaginas/Perfil.js';
import Produto from './ItensPaginas/Produtos.js';
import DetalheProduto from './ItensPaginas/DetalheProduto.js';
import LoginCadastro from './ItensPaginas/LoginCadastro.js';
import Checkout from './ItensPaginas/Checkout.js';

function PaginaItem({ DadosAPI }) {

    const itemPagina = DadosAPI.pagina.paginaitem;
    const navigate = useNavigate();
    const location = useLocation();

    const pathname = location.pathname;

 
 


    const RenderPage = ({ item }) => {

        console.log("item", item)

        var tipo = "" + item.idecommercepaginaitemtipo;

        if (tipo == "1") {

            return (<BannerPrincipal item={item} DadosAPI={DadosAPI} />)
        }

        if (tipo == "4") {
            return (<QuatroBanner item={item} DadosAPI={DadosAPI} />)
        }

        if (tipo == "7") {
            return (<ItemTexto item={item} DadosAPI={DadosAPI} />)
        }

        if (tipo == "8") {

            return (<Contato item={item} DadosAPI={DadosAPI} />)
        }

        if (tipo == "9") {

            return (<SetorUm item={item} DadosAPI={DadosAPI} />)
        }

        if (tipo == "10") {
            return (<Produto item={item} DadosAPI={DadosAPI} />)
        }

        return <></>
    }



    if (pathname.includes("/produto/")) {
        return (<DetalheProduto  />)
    }


    //Pages ou itens

    if(pathname == "/perfil"){
       
        return(
            <>
            <Perfil DadosAPI={DadosAPI}/>
            </>
        )
    }

    if(pathname == "/checkout"){
       
        return(
            <>
            <Checkout DadosAPI={DadosAPI}/>
            </>
        )
    }


    if(pathname == '/account'){

        return(
            <>
                <LoginCadastro DadosAPI={DadosAPI}/>
            </>
        )
    }
 


    if(itemPagina == null){
        return <></>
    }


   

    

    return (
        <>

            {itemPagina.map((item) => (<>
                <RenderPage item={item} />
            </>
            ))}
        </>
    );
}

export default PaginaItem;
